import { render, staticRenderFns } from "./SettingChat.vue?vue&type=template&id=e2af34b6&"
import script from "./SettingChat.vue?vue&type=script&lang=js&"
export * from "./SettingChat.vue?vue&type=script&lang=js&"
import style0 from "./SettingChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports